var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{staticClass:"tw-mb-1 tw-font-roboto tw-text-xs lg:tw-text-base tw-leading-4 lg:tw-leading-5",class:[
    _setup.mobile()
      ? 'tw-line-clamp-' + _setup.props.lineClampMobile
      : 'tw-line-clamp-' + _setup.props.lineClampDesktop,
  ]},[_vm._v(" "+_vm._s(_setup.removeHTMLTagsFromText(_setup.props.description))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }